import request from '@utils/request'

export function fetchConfig(name) {
  return request.get(`/admin/config/${name}`)
}

export function updateConfig(name, config) {
  return request.put(`/admin/config/${name}`, config)
}
